import { Box } from '@mui/material';
import React from 'react';
import styles from './page-wrapper.module.scss';

export default function PageWrapper(props: any) {
    return <Box className={styles.pageWrapper}>
        {props.children}
    </Box>
}
